module.exports = __webpack_public_path__ + "static/media/2.Stationery-Concrete-Pump.78dad715.webp";